import { render, staticRenderFns } from "./firmabilgileri.vue?vue&type=template&id=28a72936&"
import script from "./firmabilgileri.vue?vue&type=script&lang=js&"
export * from "./firmabilgileri.vue?vue&type=script&lang=js&"
import style0 from "./firmabilgileri.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports